import { connect } from 'react-redux';

import { RootState } from '../../../../store';
import { getPricelistPeriodTableItems, getPricelistTableGroups } from '../../redux/pricelistSelectors';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { Eventcalendar, MbscCalendarEvent, MbscEventcalendarView } from '@mobiscroll/react';
import { useMemo } from 'react';
import './pricelistTimeline.css';
import { Box } from '@mui/material';
const mapStateToProps = (state: RootState) => ({
    pricelists: getPricelistTableGroups(state),
    pricelistPeriods: getPricelistPeriodTableItems(state)
});
const colors = {
    basePrice: '#32718f',
    regular: '#5ac8fa'
};
type Props = ReturnType<typeof mapStateToProps>;

const PricelistTimeline = ({ pricelists, pricelistPeriods }: Props) => {
    const view = useMemo(() => {
        return {
            timeline: {
                type: 'month',
                weekNumbers: true
            }
        } as MbscEventcalendarView;
    }, []);

    const resources = useMemo(() => {
        return pricelists.map(pl => ({ id: pl.id, name: pl.title, isBasePricelist: pl.isBasePricelist }));
    }, [pricelists]);

    const pricelistsObj = useMemo(
        () =>
            pricelists.reduce((obj, curr) => {
                obj[curr.id] = curr;
                return obj;
            }, {}) as { [pricelistId: string]: { id: number; name: string; isBasePricelist: boolean } },
        [pricelists]
    );

    const events = useMemo(
        () =>
            pricelistPeriods?.map(pp => {
                const getText = pp =>
                    `${pp.startTime.date()}/${
                        pp.startTime.month() + 1
                    } (${pp.startTime.year()}) - ${pp.endTime.date()}/${
                        pp.endTime.month() + 1
                    } (${pp.endTime.year()})`;

                return {
                    resource: pricelistsObj[pp.group].id,
                    title: pricelistsObj[pp.group].name,
                    tooltip: getText(pp),
                    start: pp.startTime.toDate(),
                    end: pp.endTime.toDate(),
                    color: pricelistsObj[pp.group].isBasePricelist ? colors.basePrice : colors.regular,
                    text: getText(pp),
                    allDay: true
                } as MbscCalendarEvent;
            }) ?? ([] as MbscCalendarEvent[]),
        [pricelistPeriods, pricelistsObj]
    );

    if (pricelists.length === 0) {
        return <div />;
    }

    return (
        <Box sx={{ maxWidth: '1200px' }}>
            <Eventcalendar theme="ios" themeVariant="light" view={view} data={events} resources={resources} />
        </Box>
    );
};
export default connect(mapStateToProps)(PricelistTimeline);
